import React, { Suspense, useCallback, useContext, useEffect, useState } from 'react'
import { TostMsg } from '../../../App';
import { getYearlyWFHApplied } from './Service/ReportService';
import ERROR_LIST from '../../../Services/Global-Services/Hadle_Errors';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { DataTable } from 'primereact/datatable';
import { Column } from 'jspdf-autotable';
import ComponentLoader from '../../../Shared/Sidebar/ComponentLoader';
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { EmployeeAwardsYears } from '../AwardList/Services/awardService';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';

function WFHApplied() {
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [Isloading, setIsloading] = useState(false);
    const toster = useContext(TostMsg);
    const [wfhApplyData, setWfhApplyData] = useState([]);

    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filteredData, setFilteredData] = useState(wfhApplyData);
    const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
    const defaultImage = "/images/placeholder_profile.png";
    const [IsExEmployeeView, setIsExEmployeeView] = useState(false);

    const [selectApplyWfh, setSelectApplyWfh] = useState([]);
    const [selectedYear, setSelectedYear] = useState();
    const [masterYear, setMasterYear] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");

    const selectedColumns = [
        "EmployeeName",
        "TotalLeavesTaken",
        "NextMonthApplied",
        "NextToNextMonthApplied",
        "JanLeaves",
        "FebLeaves",
        "MarLeaves",
        "AprLeaves",
        "MayLeaves",
        "JunLeaves",
        "JulLeaves",
        "AugLeaves",
        "SepLeaves",
        "OctLeaves",
        "NovLeaves",
        "DecLeaves",
    ];

    const [showCurrentMonthData, setShowCurrentMonthData] = useState(false);

    const todayIST = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
    );

    const currentMonthIndex = todayIST.getMonth();

    const wfhMonthColumns = [
        { field: "JanWFH", header: "Jan" },
        { field: "FebWFH", header: "Feb" },
        { field: "MarWFH", header: "Mar" },
        { field: "AprWFH", header: "Apr" },
        { field: "MayWFH", header: "May" },
        { field: "JunWFH", header: "Jun" },
        { field: "JulWFH", header: "Jul" },
        { field: "AugWFH", header: "Aug" },
        { field: "SepWFH", header: "Sep" },
        { field: "OctWFH", header: "Oct" },
        { field: "NovWFH", header: "Nov" },
        { field: "DecWFH", header: "Dec" }
    ];
    const filteredWFHMonths = wfhMonthColumns.filter((_, index) => {
        if (showCurrentMonthData) {
            return index = currentMonthIndex;
        } else {
            return index < currentMonthIndex;
        }
    });

    useEffect(() => {
        GetMasterSystemAlertList("WFH_Yearly_Taken", 1);
        getAwardYearList();
    }, []);

    useEffect(() => {
        getYearlyWFHAppliedList(currentPage, rowsPerPage);
    }, [currentPage, rowsPerPage, IsExEmployeeView, selectedYear, searchTerm]);

    const handleInputChangeExEmployee = (e) => {
        setIsExEmployeeView(e.value);
    };

    const handleInputChangeYear = (e) => {
        setSelectedYear(e.value);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0); // reset page
    };

    async function getAwardYearList() {
        const params = { OrgId: userDetails?.OrgId };
        try {
            const response = await EmployeeAwardsYears(params);

            const yearDetail = response?.Data?.reverse();
            setMasterYear(yearDetail);
            const currentYear = new Date().getFullYear().toString();
            const yearExists = yearDetail?.some(
                (item) => item.Year.toString() === currentYear
            );
            setSelectedYear(
                yearExists ? currentYear : yearDetail?.[0]?.Year
            );

        } catch (err) {
            toster.current.error(ERROR_LIST.AwardYear);
        }
    }



    function exportToCSV() {
        if (!selectApplyWfh || selectApplyWfh.length === 0) {
            toster.current.warn("Please select at least one employee");
            return;
        }
        const filteredData = selectApplyWfh.map((row) =>
            selectedColumns.reduce((acc, col) => {
                acc[col] = row?.[col] ?? "";
                return acc;
            }, {})
        );
        const csv = Papa.unparse(filteredData);
        const blob = new Blob(
            [csv],
            { type: "text/csv;charset=utf-8;" }
        );
        saveAs(blob, "WFHAppliedReport.csv");
    }

    const GetMasterSystemAlertList = useCallback(async (message, type) => {
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message && type == 0) {
                toster.current.success(msg?.Desc);
            } else if (msg?.Name == message && type == 1) {
                setMasterSystemAlertData(msg?.Desc);
            } else if (msg?.Name == message && type == 2) {
                // setMasterSystemAlertData(msg?.Desc);
            }
        });
    }, []);

    const onSortChange = (e) => {
        setSortField(e.sortField);
        setSortOrder(e.sortOrder);

        const sortedData = [...filteredData].sort((a, b) => {
            let valueA = a[e.sortField];
            let valueB = b[e.sortField];

            if (typeof valueA === "string") valueA = valueA.toLowerCase();
            if (typeof valueB === "string") valueB = valueB.toLowerCase();

            if (valueA < valueB) return e.sortOrder;
            if (valueA > valueB) return -e.sortOrder;
            return 0;
        });
        setFilteredData(sortedData);
    };

    async function getYearlyWFHAppliedList(page = 0, pageSize = 10) {
        setIsloading(true);
        const params = {
            Year: selectedYear,
            ExEmployees: IsExEmployeeView ? 1 : 0,
            SearchTerm: searchTerm,
            PageNumber: page + 1,
            PageSize: pageSize
        };
        try {
            const response = await getYearlyWFHApplied(params);
            setWfhApplyData(response?.Data || []);
            setTotalRecords(response?.Data?.[0]?.TotalCount || 0);
        } catch (err) {
            toster.current.error(ERROR_LIST.DefaultError);
        } finally {
            setIsloading(false);
        }
    }

    const onPageChange = (e) => {
        setCurrentPage(e.first / e.rows);
        setRowsPerPage(e.rows);
    };



    const handleImageError = useCallback((event) => {
        event.target.src = defaultImage; // Set the fallback image on error
    }, []);


    const styleFullName = (rowData) => {
        return (
            <Link to={`/Profile/${rowData.GUID}`}>
                <div className="d-flex align-items-center">
                    <img
                        src={rowData?.ProfileImage || defaultImage}
                        onError={handleImageError}
                        className="rounded-lg me-2"
                        width="24"
                        alt=""
                    />{" "}
                    <span className="w-space-no">
                        {rowData?.EmployeeName} ({rowData?.EmpId})
                    </span>
                </div>
            </Link>
        );
    };

    return (
        <div>
            <div className="container-fluid position-relative">
                <div className="row team-directories g-3">
                    <div className="col-xl-12">
                        <div className="form-head d-flex flex-wrap align-items-center">
                            <div className="me-auto">
                                <h2 className="font-w600 mb-0">Work From Home Summary</h2>
                                {/* <p>{masterSystemAlertData}</p */}
                                <p>All employees Work From Home (WFH) applied for the selected year.</p>
                            </div>
                            <div className="rightside-tabs">

                                <Link to="/Reports">
                                    <button className="back-newticket w-auto float-right">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            fill="currentColor"
                                            className="bi bi-arrow-left-short"
                                            viewBox="0 0 16 16"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                                            />
                                        </svg>{" "}
                                        Back
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-head row mb-3 justify-content-end">
                                    {/* <div className="me-auto">
                    <strong>All Employees ({wfhApplyData?.length})</strong>
                  </div> */}

                                    <div className="col-lg-8 col-md-12">
                                        <div className=" row gx-2 justify-content-end top-head-wfh-area">
                                            <div className="col-lg-2 d-flex align-items-center justify-content-end me-2">
                                                <input
                                                    type="checkbox"
                                                    checked={showCurrentMonthData}
                                                    onChange={() => setShowCurrentMonthData(!showCurrentMonthData)}
                                                />
                                                <label style={{ marginLeft: "3px", marginBottom: "0px", fontSize: "12px" }}>
                                                    Future Months
                                                </label>
                                            </div>
                                            <div
                                                className="select-futurepost-article col-lg-2"
                                                title="Ex-Employee View"
                                            >
                                                <label style={{ cursor: "pointer" }}>Ex-Employee</label>
                                                <div className="ml-auto d-flex">
                                                    <InputSwitch
                                                        checked={IsExEmployeeView}
                                                        onChange={(e) => handleInputChangeExEmployee(e)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="org-cate  col-lg-3 me-1">
                                                <Dropdown
                                                    name="Year"
                                                    value={selectedYear}
                                                    onChange={(e) => {
                                                        setSelectedYear(e.value);
                                                        handleInputChangeYear(e);
                                                    }}
                                                    options={masterYear}
                                                    optionLabel="Year"
                                                    optionValue="Year"
                                                    placeholder="Select a Year"
                                                    checkmark={true}
                                                    highlightOnSelect={false}
                                                />
                                            </div>

                                            <input
                                                type="text"
                                                className="form-control col-lg-3 search-height"
                                                value={searchTerm}
                                                onChange={handleSearchChange}
                                                placeholder="Search"
                                            />

                                            <div className="org-cate  col-1 text-center">
                                                <button
                                                    className="export-btn"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    title="Export"
                                                    onClick={() => exportToCSV()}
                                                >
                                                    <img
                                                        src="/images/excels.png"
                                                        alt="export"
                                                        style={{ width: "23px" }}
                                                    />
                                                </button></div>

                                            
                                        </div>
                                    </div>
                                </div>



                                <div className="table-responsive">
                                    <div className="table table-bordered Employeelist ">
                                        <DataTable
                                            value={wfhApplyData}
                                            dataKey="EmpId"
                                            paginator
                                            rows={rowsPerPage}
                                            first={currentPage * rowsPerPage}
                                            totalRecords={totalRecords}
                                            sortField={sortField}
                                            sortOrder={sortOrder}
                                            onSort={onSortChange}
                                            onPage={onPageChange}
                                            selection={selectApplyWfh}
                                            onSelectionChange={(e) => setSelectApplyWfh(e.value)}
                                            selectionPageOnly={false}
                                            rowsPerPageOptions={[5, 10, 25, 50]}
                                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                        >
                                            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                                            <Column field="EmployeeName" body={styleFullName} header="Name" />
                                            <Column field="TotalWFHTakenThisYear" header="Total YTD" />
                                            <Column field="WFHAppliedNextMonth" header="Apply Next Month" />
                                            <Column field="WFHAppliedNextToNextMonth" header="Apply Second Month" />
                                            {filteredWFHMonths.map((col, index) => (
                                                <Column key={index} field={col.field} header={col.header} />
                                            ))}
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {Isloading ? (
                <Suspense>
                    <ComponentLoader />
                </Suspense>
            ) : ("")}
        </div>
    )
}

export default WFHApplied